import React, { useEffect, useMemo, useState } from 'react';
import { Building2, RefreshCw } from 'lucide-react';
import './CondominioPage.css';

import SlideOver from '../../components/ui/SlideOver/SlideOver';
import CondominiosGrid from '../../features/condos/CondominiosGrid/CondominiosGrid';
import CondominioPanel from '../../features/condos/CondominioPanel/CondominioPanel';
import DeleteCondominioDialog from '../../features/condos/DeleteCondominioDialog/DeleteCondominioDialog';
import PageHeader from '../../components/ui/PageHeader/PageHeader';
import ListToolbar from '../../components/ui/ListToolbar/ListToolbar';

import getCondominios from '../../API/condos/Condos';

export default function CondominioPage() {
  const [q, setQ] = useState('');
  const [openCreate, setOpenCreate] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [targetCondo, setTargetCondo] = useState(null);
  const [condominios, setCondominios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const loadCondominios = async () => {
    let alive = true;
    setLoading(true);
    setErr('');

    try {
        const res = await getCondominios();
        const raw =
        Array.isArray(res?.data?.condominios)
            ? res.data.condominios
            : Array.isArray(res?.condominios)
            ? res.condominios
            : [];

        if (!Array.isArray(raw)) {
            throw new Error('payload_invalido');
        }

        const list = raw.slice().sort(sortByNameAsc);
        if (alive) setCondominios(list);

        } catch (e) {
            console.error('Falha ao carregar condomínios', e);
            if (alive) setErr('Falha ao carregar condomínios.');
        } finally {
            if (alive) setLoading(false);
    }

    return () => { alive = false; };
  };

  function sortByNameAsc(a, b) {
    return String(a.name || '').localeCompare(String(b.name || ''));
  }

  useEffect(() => {
    loadCondominios();
  }, []);

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return condominios;

    return condominios.filter((c) =>
      [c.name, c.app_url, c.city]
        .some((v) => String(v || '').toLowerCase().includes(needle))
    );
  }, [q, condominios]);

  return (
    <div className="condo-page">
    <PageHeader
        title="Condomínios"
        subtitle="Cadastre e gerencie os condomínios atendidos pelo sistema."
        icon={<Building2 strokeWidth={1.8} />}
        iconVariant="green"
        rightContent={
            <>
            <button
                type="button"
                className="condo-refresh-btn"
                onClick={loadCondominios}
                disabled={loading}
            >
                <RefreshCw
                className={loading ? 'condo-refresh-icon spinning' : 'condo-refresh-icon'}
                strokeWidth={1.8}
                />
                <span>{loading ? 'Atualizando...' : 'Atualizar lista'}</span>
            </button>

            <ListToolbar
                value={q}
                onChange={setQ}
                onNew={() => { setTargetCondo(null); setOpenCreate(true); }}
                searchPlaceholder="Buscar por nome, domínio, cidade..."
                newLabel="+ Novo condomínio"
            />
            </>
        }
    />

      <main className="condo-content">
        <section className="condo-main-card">
          <CondominiosGrid
            condominios={filtered}
            loading={loading}
            error={err}
            onEdit={(c) => { setTargetCondo(c); setOpenCreate(true); }}
            onDelete={(c) => { setTargetCondo(c); setOpenDelete(true); }}
          />
        </section>
      </main>

      <SlideOver
        open={openCreate}
        onClose={() => { setOpenCreate(false); setTargetCondo(null); }}
        title={targetCondo ? `Editar: ${targetCondo.name}` : 'Novo condomínio'}
      >
        <CondominioPanel
          mode={targetCondo ? 'edit' : 'create'}
          condominio={targetCondo}
          onClose={() => { setOpenCreate(false); setTargetCondo(null); }}
          onSaved={loadCondominios}
        />
      </SlideOver>

      <DeleteCondominioDialog
        open={openDelete}
        condominio={targetCondo}
        onClose={() => { setOpenDelete(false); setTargetCondo(null); }}
        onDeleted={loadCondominios}
      />
    </div>
  );
}